export enum JobDescriptionDialogType {
  Beneficiary = "BENEFICIARY",
  Benefit = "BENEFIT",
}
